import { Component, Inject } from "@angular/core";
import { LicenseService } from "../../../services/LicenseService";
import { MD_DIALOG_DATA, MdDialogRef } from "@angular/material";
import { AppLoaderService } from "../../../../services/app-loader/app-loader.service";
import { apply } from "core-js/fn/reflect";
import { Router } from "@angular/router";
import { AdalService } from "../../../shared/adal.service";

@Component({
    selector:'service360-view-activation-details',
    styles:[require('./service360-view-activation-details.component.css')],
    template:require('./service360-view-activation-details.component.html')
})
export class Service360ViewActivationDetailComponent{
    dialogTitle='View License Activation Details'
    errorMessage=''
    SelectedLicenseDetail;
    ActivationDetail;
    error='';
    isLoading=false;
    constructor(
        private licenseService:LicenseService, 
        private appLoader:AppLoaderService,
        private dialogRef:MdDialogRef<Service360ViewActivationDetailComponent>,
        private adalService:AdalService,
        private router:Router,
        @Inject(MD_DIALOG_DATA) public dialogData: any
    ){
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.SelectedLicenseDetail=this.dialogData.SelectedLicenseDetail;
        this.getActivationDetails();
    }
    getActivationDetails(){
        this.isLoading=true;
        this.licenseService.viewService360ActivationHistory(this.SelectedLicenseDetail.LicenseId).subscribe((data)=>{
           if(!data.IsError && data.DataObject!=null){
                this.ActivationDetail=data.DataObject;
                this.error='';
           }
           else{
            this.error=data.Error;
           }
           this.isLoading=false;
        })
    }
    onCancel(){
        this.dialogRef.close();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/service360/service360-view-activation-details/service360-view-activation-details.component.ts